import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class DeleteASurvey extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Survey/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetSurveyById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Survey/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}


class GetAllSurveys extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Survey/GetEnable");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { DeleteASurvey, GetSurveyById, GetAllSurveys };
